import { useMyBusinesses } from "../../../../../hooks/useMyBusinesses";
import ProductDetailHelper from "../../../../../services/helpers/ProductDetailHelper";

/**
 * A business owner/collaborator managing a business listing may not be the
 * literal sellerId on the product, so this covers both: the direct seller,
 * and an owner/collaborator on the listing's business.
 */
export function useCanManageListing(isCurrentUserSeller: boolean, businessId: string | undefined): boolean {
  const { businesses: myBusinesses } = useMyBusinesses();
  const isCurrentUserOwnerOrCollaborator = ProductDetailHelper.isCurrentUserOwnerOrCollaborator(businessId, myBusinesses);

  return isCurrentUserSeller || (isCurrentUserOwnerOrCollaborator && !!businessId);
}
